module.exports = __webpack_public_path__ + "static/media/downloadIcon.ee2a50aa.svg";